import React from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

interface SubscriptionExpiredProps {
  // You can add props if needed
}

const SubscriptionExpired: React.FC<SubscriptionExpiredProps> = () => {
  const navigate = useNavigate();

  const contactSupport = () => {
    // Open email client with support email
    window.open('mailto:support@3sigmacrm.com?subject=Subscription%20Support', '_blank');
    toast.success('Opening email client to contact support');
  };

  const openWhatsapp = () => {
    window.open('https://wa.me/917015823248', '_blank');
    toast.success('Opening WhatsApp to contact support');
  };

  const callSupport = () => {
    window.open('tel:+917015823248', '_blank');
    toast.success('Calling support');
  };

  const explorePricing = () => {
    window.open('https://www.3sigmacrm.com/pricing', '_blank');
    toast.success('Opening pricing page');
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-5 col-xl-4 mt-5">
          <div 
            className="card shadow-lg p-4" 
            style={{
              borderRadius: '15px',
              backgroundColor: '#ebeff4',
            }}
          >
            <div className="d-flex flex-column align-items-center">
              {/* Logo */}
              <img
                src="assets/img/3sigma_logo.png"
                alt="3Sigma CRM"
                className="mb-4"
                style={{
                  width: '100%',
                  maxWidth: '200px',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
              
              {/* Warning Icon */}
              <div 
                className="d-flex justify-content-center align-items-center mb-4"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#E6F0FF',
                }}
              >
                <span 
                  style={{
                    fontSize: '40px',
                    fontWeight: 'bold',
                    color: '#3A4B86',
                  }}
                >!</span>
              </div>
              
              {/* Message */}
              <h2 
                className="text-center mb-3" 
                style={{ 
                  fontWeight: 'bold',
                  color: '#333',
                  fontSize: '1.75rem',
                }}
              >
                Subscription Expired
              </h2>
              
              <p 
                className="text-center text-muted mb-4" 
                style={{ fontSize: '1rem' }}
              >
                Your subscription period has ended. Please contact our support team to
                renew your subscription and continue using 3Sigma CRM.
              </p>
              
              {/* Action Buttons */}
              <div className="w-100">
                <button
                  onClick={openWhatsapp}
                  className="btn btn-primary w-100 mb-3"
                  style={{
                    backgroundColor: '#3A4B86',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    borderRadius: '8px',
                    padding: '12px',
                    border: 'none',
                  }}
                >
                  Contact on WhatsApp
                </button>
                
                <button
                  onClick={callSupport}
                  className="btn btn-primary w-100 mb-3"
                  style={{
                    backgroundColor: '#3A4B86',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    borderRadius: '8px',
                    padding: '12px',
                    border: 'none',
                  }}
                >
                  Call Support
                </button>
                
                <button
                  onClick={explorePricing}
                  className="btn btn-primary w-100 mb-3"
                  style={{
                    backgroundColor: '#3A4B86',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    borderRadius: '8px',
                    padding: '12px',
                    border: 'none',
                  }}
                >
                  Explore Pricing
                </button>
                
                <button
                  onClick={() => navigate('/')}
                  className="btn btn-outline-primary w-100"
                  style={{
                    color: '#3A4B86',
                    borderColor: '#3A4B86',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    borderRadius: '8px',
                    padding: '12px',
                  }}
                >
                  Return to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;